(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item summary').forEach((summary) => {
    summary.addEventListener('click', (e) => {
      // Allow default details toggle behavior
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.getElementById('FooterBackToTop')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-track-order"]) return;
  try {
    
  const form = document.getElementById('TrackOrderForm');
  const input = document.getElementById('TrackingInput');
  const result = document.getElementById('TrackingResult');
  const displayNum = document.getElementById('TrackingDisplayNum');

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    const val = input?.value?.trim();
    if (val && result && displayNum) {
      displayNum.textContent = val;
      result.style.display = 'block';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
